/* 
    Cookie for cookie policy alert
    
    abstract
    --
    setCookie()
    getCookie()
    
    
    specific
    --
    checkCookieClosed()
*/
var $ = jQuery;

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookieClosed() {

    var cookieAlertCheck = getCookie('cookie-alert');

    if (cookieAlertCheck == "closed") {
        return true;
    }
}


$(document).ready(function() {
    $('.cookie-policy__close').on('click', closeCookieAlert);


    function closeCookieAlert() {

        $('.cookie-policy').hide();
        setCookie('cookie-alert', 'closed', 10);
    };

    var cookieAlertClosed = checkCookieClosed();

    if (cookieAlertClosed) {}

    else {
        $('.cookie-policy').css('display', 'block');
    }

});
